import { render, staticRenderFns } from "./BrunetteMenuOpen.vue?vue&type=template&id=049468e1&"
import script from "./BrunetteMenuOpen.vue?vue&type=script&lang=ts&"
export * from "./BrunetteMenuOpen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports